import React from 'react'
import './Services.css'
import Heading from '../../common/heading/Heading'

const specialties = [
  {
    icon: "/assets/images/car-parts-white.png",
    title: "Parts",
    desc: "For riders looking to upgrade performance, style, and reliability. From exhaust systems, suspension, and lighting to handlebars, fairings, and performance components, we ensure every part is installed correctly and built to perform.",
  },
  {
    icon: "/assets/images/car-engine-white.png",
    title: "Installation",
    desc: "Professional motorcycle installation services tailored to performance, comfort, and style. From aftermarket upgrades and custom accessories to performance components, our experienced team ensures every installation is done with precision and attention to detail.",
  },
  {
    icon: "/assets/images/speedometer-white.png",
    title: "Tuning",
    desc: "We specialize in motorcycle tuning designed to maximize performance, throttle response, and rideability. Whether your bike is stock or fully modified, we use professional tuning methods to optimize fuel mapping and engine performance for smoother power delivery and increased reliability. From street bikes to track-focused builds, we tailor every tune to fit your motorcycle and riding style.",
  },
];

const Services = () => {
  return (
    <section className="services-section">
      <div className="services-inner text-block">
        <Heading eyebrow="What we do">Service & Parts Installation</Heading>
        <p className="services-lead">
          We specialize in professional motorcycle maintenance, diagnostics, and
          repair for riders who demand reliability and performance. From routine
          services like oil changes, brake work, chain adjustments, and tire
          installation to advanced engine diagnostics and performance upgrades,
          our shop is dedicated to keeping your bike running at its best.
          Whether you ride a sport bike, cruiser, touring bike, or custom build,
          we combine years of hands-on experience with attention to detail to
          deliver dependable service you can trust. At GW Motorsports, we treat
          every motorcycle like it’s our own and every customer like part of the
          riding community.
        </p>

        <div className="specialties-grid">
          {specialties.map((s) => (
            <article className="specialty-card" key={s.title}>
              <div className="specialty-icon-wrap">
                <img src={s.icon} alt="" width={44} />
              </div>
              <h3 className="specialty-title">{s.title}</h3>
              <p className="specialty-desc">{s.desc}</p>
            </article>
          ))}
        </div>

        {/* <div className="services-foot">
          <p>
            GW Motorsports installs every part under the sun. Our facility is
            conveniently located in Waxahachie, TX with{" "}
            <strong>4 full service bays</strong>.
          </p>
        </div> */}
      </div>
    </section>
  );
};

export default Services
